/**
 * This helper unlike ng.$location is independent and can be used in any place
 */
const helper = {
  /**
   * Returns value of GET parameter
   *
   * @param paramName - get parameter name
   * @param url - url to parse from, by default uses window.location
   */
  getParam(paramName: string, url?: string): string {
    return helper.extractParameter(paramName, '?', url);
  },

  /**
   * Returns value of a Hash parameter
   *
   * @param paramName - get parameter name
   * @param url – an href of location,
   *              useful when parsing location from other window,
   *              defaults to location.href of current window
   * @returns {boolean|String}
   */
  hashParam(paramName: string, url?: string): string {
    return helper.extractParameter(paramName, '#', url);
  },

  extractParameter(paramName: string, separator: string, url?: string): string {
    let result: string = '';

    const urlParts = (url || helper.getUrl()).split(separator);
    // In case there are multiple separator signs in the url
    urlParts.shift();
    const urlAfterHash = urlParts.join(separator);

    if (!urlAfterHash) {
      return result;
    }

    urlAfterHash.split('&').forEach(item => {
      const name = item.split('=', 1)[0];
      if (name === paramName) {
        result = decodeURIComponent(item.slice(name.length + 1));
      }
    });

    return result;
  },

  /**
   * Return page absolute url
   * Extracted for the unit tests purpose
   *
   * @returns {string}
   */
  getUrl: (): string => location.href
};

export default helper;
